import { useEffect, useMemo } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../features/table/helpers';
import {
  defaultPage,
  defaultPageSize,
  defaultViewStyle,
  pageKey,
  pageSizeKey,
  viewStyleKey,
} from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useModalParams } from '../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../store/use-branch-store';
import { useEmployeesStore } from '../../../../store/use-employee-store';
import { useSchedulerStore } from '../../../../store/use-scheduler-store';
import { SortType } from '../../../../types/props';

export const useTaskPlanner = () => {
  const { t } = useLang();
  const { fetchList, pagination, isLoading } = useSchedulerStore();
  const { fetchEmployees } = useEmployeesStore();
  const { fetchBranches } = useBranchesStore();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const viewStyle = params[viewStyleKey] || defaultViewStyle;
  const employee = params.employee;
  const branch = params.branch;

  const page = params[pageKey] || defaultPage;
  const pageSize = params[pageSizeKey] || defaultPageSize;

  const requestParams = useMemo(() => {
    return {
      is_by_company: true,
      since_id: 0,
      n: 1000,
      employee,
      place_ids: branch?.split(',').map((item) => Number(item)),
      field: sortField,
      dir: sortDirection,
      page,
      page_size: pageSize,
    };
  }, [employee, sortField, sortDirection, branch, page, pageSize, viewStyle]);

  useEffect(() => {
    fetchList(requestParams);
  }, [requestParams]);

  useEffect(() => {
    fetchEmployees({ page: 1, page_size: 1000, is_by_company: true, is_available: true });
    fetchBranches({ n: 1000, since_id: 0, is_by_company: true });
  }, []);

  const {
    handleCloseModal: handleCloseCreateScheduleModal,
    handleOpenModal: handleOpenCreateScheduleModal,
    isOpen: isOpenCreateScheduleModal,
  } = useModalParams('createSchedule');

  const handleEnd = () => {
    if (isLoading || !pagination || pagination.is_last) return;
    const nextPage = pagination.page + 1;
    fetchList({ ...requestParams, page: nextPage, infinite: true });
  };

  return {
    t,
    viewStyle,
    pagination,
    isOpenCreateScheduleModal,
    handleCloseCreateScheduleModal,
    handleOpenCreateScheduleModal,
    handleEnd,
  };
};
